module.exports = __webpack_public_path__ + "img/logo.6e82c6a9.png";